import abd from './vendor/adBlockDetectionLib.js';
export default {
    run() {
        return new Promise((resolve, reject) => {
            if (abd.init) {
                try {
                    abd.init({
                        complete: resolve,
                    });
                }
                catch (error) {
                    reject(error);
                }
            }
            else {
                reject(new Error('Failed to initialise adblock detection'));
            }
        });
    },
};
